import { createContext } from 'react';
import type { CommandManager } from './CommandManager';

export const CommandManagerContext = createContext<CommandManager | null>(null);
